import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

export function heroAnimations() {
  const hero = document.querySelector(".hero");
  if (!hero) return;

  const heroTitle = hero.querySelector(".hero__title h1");
  const heroSubtitle = hero.querySelector(".hero__subtitle p");

  if (!heroTitle) return;

  // stato iniziale
  gsap.set(heroTitle, { autoAlpha: 0, y: 60 });
  if (heroSubtitle) gsap.set(heroSubtitle, { autoAlpha: 0, y: 40 });

  // animazioni (N.B. niente clearProps)
  gsap.to(heroTitle, {
    autoAlpha: 1,
    y: 0,
    duration: 1.2,
    ease: "power2.out",
    overwrite: "auto",
    scrollTrigger: {
      trigger: hero,
      start: "top 80%",
      once: true
    }
  });

  if (heroSubtitle) {
    gsap.to(heroSubtitle, {
      autoAlpha: 1,
      y: 0,
      duration: 1.0,
      ease: "power2.out",
      delay: 0.15,
      overwrite: "auto",
      scrollTrigger: {
        trigger: hero,
        start: "top 80%",
        once: true
      }
    });
  }
}